export enum CrudBulkSteps {
  None,
  SelectAction,
  ProcessAction,
  Preview,
  Summary,
}
